import { ListItemText, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/system";
import { useEffect, useState } from "react";
import shortid from "shortid";
import List from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { StyledList, StyledListItemButton, StyledListItemIcon, StyledListItemText, SubItem } from "./components";
import SubItemCloseIcon from "assets/icons/SubItemCloseIcon";
import SubItemOpenIcon from "assets/icons/SubItemOpenIcon";
import { PriceComponent } from "components/Shared/Dashboard/styled";
import { formatPrice } from "helpers/dataFormat";
import { useSelector } from "react-redux";
import ScrollContainer from "react-indiana-drag-scroll";

const StyledSubItem = styled(SubItem)({
  backgroundColor: "#F0F5FC",
  width: "100%"
});

const SubListItemText = styled(ListItemText)({
  paddingRight: "10px",
  minWidth: "calc(10rem + 30px)"
});
const SubListItemTextRight = styled("div")({
  // maxWidth: "48rem",
  display: "flex",
  // minWidth: "42rem",
  gap: "10px"
  // gridTemplateColumns: "40% 40%",
  // justifyContent: "space-between",
  // textAlign: "right"
});
const SubText = styled(Typography)({
  // padding: "10px",
  width: "25%",
  textAlign: "right"
});

const ListSubItem = ({ data, paddingRight, addTrialBalanceItem, columnNumber }: { data: balanceSheetChildType, columnNumber: string, paddingRight: number; addTrialBalanceItem: (item: any) => void }) => {
  //@ts-ignore
  const { openReports } = useSelector((state) => state).appReducer as { openReports: boolean };
  const [open, setOpen] = useState(openReports);

  useEffect(() => {
    setOpen(openReports);
  }, [openReports]);

  const childPaddingRight = paddingRight + 20;

  const handleClick = () => {
    setOpen(!open);
  };

  const isCreditor = data.amount >= 0;
  const debtAmount = isCreditor ? 0 : data.amount;
  const creditAmount = isCreditor ? data.amount : 0;

  const theme = useTheme();
  if (data.childs) {
    addTrialBalanceItem({
      "عنوان": data.title,
      "کد": data.code,
      "گردش بدهکار": Math.abs(data.debtAmount).toLocaleString("en-US"),
      "گردش بستانکار": Math.abs(data.creditAmount).toLocaleString("en-US"),
      "مانده بدهکار": Math.abs(debtAmount).toLocaleString("en-US"),
      "مانده بستانکار": Math.abs(creditAmount).toLocaleString("en-US")
    })
    return (
      <>
        <StyledListItemButton
          disableRipple
          active={open}
          onClick={handleClick}
          paddingRight={childPaddingRight}
        >
          <StyledListItemIcon>{open ? <SubItemCloseIcon /> : <SubItemOpenIcon />}</StyledListItemIcon>
          <StyledListItemText>
            <Typography variant="body2">{`${data.code ? data.code : ""}-${data.title}`}</Typography>
          </StyledListItemText>
          <SubListItemTextRight
            sx={{ minWidth: columnNumber === '6' || columnNumber === "8" ? '90rem' : '42rem'  }}
          >
            {columnNumber == "2" ?
              <>
                <div style={{ width: "25%" }}>
                  <PriceComponent
                    color={debtAmount != 0 ? theme.palette.error.main : ""}
                    price={formatPrice(debtAmount)}
                  />
                </div>
                <div style={{ width: "25%" }}>
                  <PriceComponent
                    color={creditAmount != 0 ? theme.palette.success.main : ""}
                    price={formatPrice(creditAmount)}
                  />
                </div>
              </>
              : columnNumber == "4" ?
                <>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={data.debtAmount != 0 ? theme.palette.error.main : ""}
                      price={formatPrice(data.debtAmount ?? 0)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={data.creditAmount != 0 ? theme.palette.success.main : ""}
                      price={formatPrice(data.creditAmount ?? 0)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={debtAmount != 0 ? theme.palette.error.main : ""}
                      price={formatPrice(debtAmount)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={creditAmount != 0 ? theme.palette.success.main : ""}
                      price={formatPrice(creditAmount)}
                    />
                  </div>
                </>
                : columnNumber == "6" ?
                  <>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={data.debtAmount != 0 ? theme.palette.error.main : ""}
                        price={formatPrice(data.debtAmount ?? 0)}
                      />
                    </div>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={data.creditAmount != 0 ? theme.palette.success.main : ""}
                        price={formatPrice(data.creditAmount ?? 0)}
                      />
                    </div>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={debtAmount != 0 ? theme.palette.error.main : ""}
                        price={formatPrice(debtAmount)}
                      />
                    </div>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={creditAmount != 0 ? theme.palette.success.main : ""}
                        price={formatPrice(creditAmount)}
                      />
                    </div>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={creditAmount != 0 ? theme.palette.success.main : ""}
                        price={formatPrice(data.debtAmountOpening ?? 0)}
                      />
                    </div>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={creditAmount != 0 ? theme.palette.success.main : ""}
                        price={formatPrice(data.creditAmountOpening ?? 0)}
                      />
                    </div>

                  </>
                  :
                  <>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={data.debtAmount != 0 ? theme.palette.error.main : ""}
                        price={formatPrice(data.debtAmount ?? 0)}
                      />
                    </div>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={data.creditAmount != 0 ? theme.palette.success.main : ""}
                        price={formatPrice(data.creditAmount ?? 0)}
                      />
                    </div>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={debtAmount != 0 ? theme.palette.error.main : ""}
                        price={formatPrice(debtAmount)}
                      />
                    </div>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={creditAmount != 0 ? theme.palette.success.main : ""}
                        price={formatPrice(creditAmount)}
                      />
                    </div>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={creditAmount != 0 ? theme.palette.success.main : ""}
                        price={formatPrice(data.debtAmountOpening ?? 0)}
                      />
                    </div>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={creditAmount != 0 ? theme.palette.success.main : ""}
                        price={formatPrice(data.creditAmountNow ?? 0)}
                      />
                    </div>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={creditAmount != 0 ? theme.palette.success.main : ""}
                        price={formatPrice(data.debtAmountNow ?? 0)}
                      />
                    </div>
                    <div style={{ width: "25%" }}>
                      <PriceComponent
                        color={creditAmount != 0 ? theme.palette.success.main : ""}
                        price={formatPrice(data.creditAmountNow ?? 0)}
                      />
                    </div>

                  </>
            }

          </SubListItemTextRight>
        </StyledListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {data.childs &&
              data.childs.map((item) => (
                <ListSubItem paddingRight={childPaddingRight} data={item} key={shortid.generate()} addTrialBalanceItem={addTrialBalanceItem} columnNumber={columnNumber} />
              ))}
          </List>
        </Collapse>
      </>
    );
  } else {
    addTrialBalanceItem({
      "عنوان": data.title,
      "کد": data.code,
      "گردش بدهکار": Math.abs(data.debtAmount).toLocaleString("en-US"),
      "گردش بستانکار": Math.abs(data.creditAmount).toLocaleString("en-US"),
      "مانده بدهکار": Math.abs(debtAmount).toLocaleString("en-US"),
      "مانده بستانکار": Math.abs(creditAmount).toLocaleString("en-US")
    })
    return (
      <SubItem paddingRight={childPaddingRight}>
        <SubListItemText>
          <Typography variant="body2">{`${data.code ? data.code : ""}-${data.title}`}</Typography>
        </SubListItemText>
        <SubListItemTextRight sx={{ minWidth: columnNumber === '6' || columnNumber === "8" ? '90rem' : '42rem'  }}>
          {columnNumber == "2" ?
            <>
              <div style={{ width: "25%" }}>
                <PriceComponent
                  color={debtAmount != 0 ? theme.palette.error.main : ""}
                  price={formatPrice(debtAmount)}
                />
              </div>
              <div style={{ width: "25%" }}>
                <PriceComponent
                  color={creditAmount != 0 ? theme.palette.success.main : ""}
                  price={formatPrice(creditAmount)}
                />
              </div>
            </>
            : columnNumber == "4" ?
              <>
                <div style={{ width: "25%" }}>
                  <PriceComponent
                    color={data.debtAmount != 0 ? theme.palette.error.main : ""}
                    price={formatPrice(data.debtAmount ?? 0)}
                  />
                </div>
                <div style={{ width: "25%" }}>
                  <PriceComponent
                    color={data.creditAmount != 0 ? theme.palette.success.main : ""}
                    price={formatPrice(data.creditAmount ?? 0)}
                  />
                </div>
                <div style={{ width: "25%" }}>
                  <PriceComponent
                    color={debtAmount != 0 ? theme.palette.error.main : ""}
                    price={formatPrice(debtAmount)}
                  />
                </div>
                <div style={{ width: "25%" }}>
                  <PriceComponent
                    color={creditAmount != 0 ? theme.palette.success.main : ""}
                    price={formatPrice(creditAmount)}
                  />
                </div>
              </>
              : columnNumber == "6" ?
                <>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={data.debtAmount != 0 ? theme.palette.error.main : ""}
                      price={formatPrice(data.debtAmount ?? 0)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={data.creditAmount != 0 ? theme.palette.success.main : ""}
                      price={formatPrice(data.creditAmount ?? 0)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={debtAmount != 0 ? theme.palette.error.main : ""}
                      price={formatPrice(debtAmount)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={creditAmount != 0 ? theme.palette.success.main : ""}
                      price={formatPrice(creditAmount)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={creditAmount != 0 ? theme.palette.success.main : ""}
                      price={formatPrice(data.debtAmountOpening ?? 0)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={creditAmount != 0 ? theme.palette.success.main : ""}
                      price={formatPrice(data.creditAmountOpening ?? 0)}
                    />
                  </div>

                </>
                :
                <>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={data.debtAmount != 0 ? theme.palette.error.main : ""}
                      price={formatPrice(data.debtAmount ?? 0)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={data.creditAmount != 0 ? theme.palette.success.main : ""}
                      price={formatPrice(data.creditAmount ?? 0)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={debtAmount != 0 ? theme.palette.error.main : ""}
                      price={formatPrice(debtAmount)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={creditAmount != 0 ? theme.palette.success.main : ""}
                      price={formatPrice(creditAmount)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={creditAmount != 0 ? theme.palette.success.main : ""}
                      price={formatPrice(data.debtAmountOpening ?? 0)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={creditAmount != 0 ? theme.palette.success.main : ""}
                      price={formatPrice(data.creditAmountOpening ?? 0)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={creditAmount != 0 ? theme.palette.success.main : ""}
                      price={formatPrice(data.debtAmountNow ?? 0)}
                    />
                  </div>
                  <div style={{ width: "25%" }}>
                    <PriceComponent
                      color={creditAmount != 0 ? theme.palette.success.main : ""}
                      price={formatPrice(data.creditAmountNow ?? 0)}
                    />
                  </div>
                      </>
          }
        
        </SubListItemTextRight>
      </SubItem>
    );
  }
};

const TrialBalanceList = ({ data, addTrialBalanceItem, sumAmountFinal, columnNumber }: { data: reportProfitAndLossDataType; addTrialBalanceItem: (item: any) => void, sumAmountFinal: any[], columnNumber: string }) => {
  const initialPaddingRight = 0;
  const getSumInfo = (colName: string) => {
    const val = sumAmountFinal.find(x => x[colName])
    if (val) {
      return val[colName]
    }
    return 0
  }
  const theme = useTheme();
  return (
    <div style={{ position: "relative" }}>
      <div className="body-table" style={{ direction: "rtl" }}>
        <ScrollContainer className="scroll-container">
          <StyledList
            // className="warp-table"
            sx={{ minWidth: "fit-content", bgcolor: "background.paper", marginBottom: "10px", padding: 0 }}
            aria-labelledby="nested-list-subheader"
          >
            <StyledSubItem>
              <SubListItemText>
                <Typography variant="body2">حساب</Typography>
              </SubListItemText>
              <SubListItemTextRight
                sx={{ minWidth: columnNumber === '6' || columnNumber === "8" ? '90rem' : '42rem'  }}
              >{
                  columnNumber == "2" ? <>
                    <SubText variant="body2">مانده بدهکار</SubText>
                    <SubText variant="body2">مانده بستانکار</SubText>
                  </> : columnNumber == "4" ? <>
                    <SubText variant="body2">گردش بدهکار</SubText>
                    <SubText variant="body2">گردش بستانکار</SubText>
                    <SubText variant="body2">مانده بدهکار</SubText>
                    <SubText variant="body2">مانده بستانکار</SubText>
                  </>
                    : columnNumber == "6" ?
                      <>
                        <SubText variant="body2">گردش بدهکار</SubText>
                        <SubText variant="body2">گردش بستانکار</SubText>
                        <SubText variant="body2">مانده بدهکار</SubText>
                        <SubText variant="body2">مانده بستانکار</SubText>
                        <SubText variant="body2">بدهکار اول دوره</SubText>
                        <SubText variant="body2">بستانکار اول دوره</SubText>
                      </> : 
                      <>
                      <SubText variant="body2">گردش بدهکار</SubText>
                        <SubText variant="body2">گردش بستانکار</SubText>
                        <SubText variant="body2">مانده بدهکار</SubText>
                        <SubText variant="body2">مانده بستانکار</SubText>
                        <SubText variant="body2">بدهکار اول دوره</SubText>
                        <SubText variant="body2">بستانکار اول دوره</SubText>
                        <SubText variant="body2">بدهکار طی دوره</SubText>
                        <SubText variant="body2">بستانکار طی دوره</SubText>
                      </>



                }
              </SubListItemTextRight>
            </StyledSubItem>
            {data.childs &&
              data.childs.map((item) => (
                <ListSubItem paddingRight={initialPaddingRight} data={item} key={shortid.generate()} addTrialBalanceItem={addTrialBalanceItem} columnNumber={columnNumber} />
              ))}
            <ListSubItem paddingRight={initialPaddingRight} data={{ code: "", title: "جمع کل", amount: 0, creditAmount: getSumInfo("creditAmount"), debtAmount: getSumInfo("debtAmount"), }} key={shortid.generate()} addTrialBalanceItem={addTrialBalanceItem} columnNumber={columnNumber} />

          </StyledList>
        </ScrollContainer>
      </div>
    </div>
  );
};

export default TrialBalanceList;
